import React from "react";

// reactstrap components
import {
	Button, Card, CardBody, CardFooter, FormGroup, Form, Input, Row, Col
} from "reactstrap";
import {motion} from "framer-motion";
import RefStrap from "../lib/Utils/RefStrap";

const MotionCard = motion(RefStrap(Card));

function Settings()
{
	return (<div className="content">
			<Row>
				<Col md="12">
					<MotionCard initial={{width: "50%", height: "20%"}} animate={{width: "100%", height: "auto", transition: {duration: 0.3, ease: "easeOut"}}}>
						<CardBody>
							<h5>Notification settings</h5>
							<p className={"text-muted"}>
								In here you can configure the maximum amount of notifications are sent in a certain amount of time. (ie. 80 notifications)
							</p>
							<br/>
							<Form>
								<Row form style={{padding: "0 15px"}}>
									<Col md={4}>
										<FormGroup>
											<Input type="number" name={"notifAmt"} placeholder={"How many notifications"}/>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Input type="select" name={"frecuency"}>
												<option value={0}>Choose a frequency</option>
												<option value={1}>Minutes</option>
												<option value={2}>Hours</option>
												<option value={3}>Days</option>
											</Input>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Input type="number" name={"feqValue"} placeholder={"Time value"}/>
										</FormGroup>
									</Col>
								</Row>
							</Form>
						</CardBody>
						<CardFooter className={"align-content text-right"} style={{padding:"0 40px 25px 0"}}>
							<hr/>
							<Button className={"btn-primary"} onClick={(e) => e.preventDefault()}>Save Settings</Button>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
			<Row>
				<Col md="12">
					<MotionCard initial={{width: "50%", height: "20%"}} animate={{width: "100%", height: "auto", transition: {duration: 0.5, ease: "easeOut"}}}>
						<CardBody>
							<h5>Stock Level Thresholds</h5>
							<p className={"text-muted"}>
								This parameter sets the minimal amount of cards to have in stock before the platform starts notifying/buying to keep the stock level
							</p>
							<br/>
							<Form>
								<Row form style={{padding: "0 15px"}}>
									<Col md={12}>
										<FormGroup>
											<Input type="number" name={"minTotalAmount"} placeholder={"Minimum Total Amount of Gift Cards"}/>
										</FormGroup>
									</Col>
								</Row>
							</Form>
						</CardBody>
						<CardFooter className={"align-content text-right"} style={{padding:"0 40px 25px 0"}}>
							<hr/>
							<Button className={"btn-primary"} onClick={(e) => e.preventDefault()}>Save Settings</Button>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
		</div>
	);
}

export default Settings;
